import React, { PropsWithChildren } from "react";

import { Link, useLocation } from "react-router-dom";
import { Typography, Grid } from "@mui/material";
import MaskedInput from "react-text-mask";
import { omit } from "lodash";
import { US_PHONE_MASK } from "utils/phone";
import { PasswordValidationType } from "components/login/utils";
import { loginStyles } from "./styles";

type LoneGridProps = {
  wide?: boolean;
  blue?: boolean;
};

export const LoneGrid: React.FC<PropsWithChildren<LoneGridProps>> = (props) => (
  <div style={{ margin: props.wide ? "8px 0px" : "8px" }}>
    <Grid container spacing={2} direction="column" alignItems="center" justifyContent="center" style={props.blue ? { backgroundColor: "#32445A" } : {}} >
      {props.children}
    </Grid>
  </div>
);

export const BackToLogin: React.FC = () => {
  const location = useLocation();
  return (
    <LoneGrid>
      <Typography style={loginStyles.bottomLink}>
      Back to <Link to={`/login${location.search}`}>Log In</Link>
      </Typography>
    </LoneGrid>
  );
};

export const SignUpLink: React.FC = () => (
  <LoneGrid>
    <Typography style={loginStyles.bottomLink} >
      Don&apos;t have an account yet? &nbsp;
      <Link to="../properties">Find Housing</Link>
    </Typography>
  </LoneGrid>
);


export const HavenConnectLoginLogo: React.FC<{ dark?: boolean }> = (props) => (
  <LoneGrid>
    <Link to="/">
      <div style={props.dark ? loginStyles.logoLoginDark : loginStyles.logoLogin} />
    </Link>
  </LoneGrid>
);

type LoginCardTitleProps = { title: string | React.ReactNode }
export const LoginCardTitle: React.FC<LoginCardTitleProps> = (props) => (
  <Typography align="center" variant="h2" style={loginStyles.titleMessage}>
    {props.title}
  </Typography>
);

export const LoginCardSubtitle: React.FC<PropsWithChildren> = (props) => (
  <Typography align="center" style={loginStyles.instructionsMessage}>
    {props.children}
  </Typography>
);


export const TextMaskCustom: React.FC = (props) => {
  const other = omit(props, ["inputRef"]);

  return (
    <MaskedInput
      {...other}
      mask={US_PHONE_MASK}
      placeholderChar={"\u2000"}
    />
  );
};


export const PasswordValidations: React.FC<{errors: PasswordValidationType[]}> = ({ errors }) => (
  <ul style={loginStyles.passwordRequirements}>
    {errors
      .filter(({ field }) => field === "password")
      .map((error, idx) => <li key={idx}>{error.shortMessage}</li>)}
  </ul>);
